export type QuotedSolarModuleSpec = {
  panelCapacityW: number;
  openCircuitVoltageV?: number | null;
  shortCircuitCurrentA?: number | null;
};

/** Configurations preserve target DC power; physical layouts preserve placed modules. */
export const resolveQuotedSolarModules = (
  source: {
    panelsCount: number;
    panelCapacityWatts: number;
    preservePanelCount: boolean;
  },
  moduleSpec?: QuotedSolarModuleSpec | null
) => ({
  panelsCount:
    moduleSpec && source.panelsCount > 0 && !source.preservePanelCount
      ? Math.max(
          1,
          Math.round(
            (source.panelsCount * source.panelCapacityWatts) /
              moduleSpec.panelCapacityW
          )
        )
      : source.panelsCount,
  panelCapacityWatts: moduleSpec?.panelCapacityW ?? source.panelCapacityWatts,
  moduleVocV: moduleSpec?.openCircuitVoltageV ?? null,
  moduleIscA: moduleSpec?.shortCircuitCurrentA ?? null,
});
